module.exports = __webpack_public_path__ + "289f09641987b0a999007a10303f2065.svg";